




















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { objectify } from "@/helpers";

@Component
export default class Dependants extends Vue {
  @Prop({ required: true }) onChange!: Function;
  @Prop({ required: true }) submit!: Function;
  @Prop({ required: true }) name!: "spouse" | "child";
  @Prop({ required: true }) lead!: any;

  total = 1;
  menu: any = {};

  mounted() {
    this.calculateTotal();
  }

  @Watch("lead")
  onLeadUpdate(val: any, prevVal: any) {
    this.calculateTotal();
  }

  calculateTotal() {
    if (this.name === "child" && this.lead.child) {
      const childKeys = Object.keys(this.lead.child);
      this.total = childKeys.length;
    } else {
      this.total = 1;
    }
  }

  addField() {
    this.total++;
  }

  removeField() {
    if (this.total > 0) {
      this.total--;
    }
  }

  getLabel(type: string, index: string) {
    if (this.name === "spouse") {
      return `Spouse ${type}`;
    }
    return `Child ${Number(index + 1)} ${type}`;
  }

  getValue(field: string, index: string) {
    if (this.name === "spouse") {
      if (!this.lead.spouse) {
        return "";
      } else {
        return this.lead.spouse[field];
      }
    } else {
      if (!this.lead.child || !this.lead.child[index]) {
        return "";
      } else {
        return this.lead.child[index][field];
      }
    }
  }

  handleChange(val: string, field: string, index: string) {
    if (this.name === "spouse") {
      this.onChange(`spouse.${field}`, val, this.name);
    } else if (this.name === "child") {
      const key = `child.${index}.${field}`;
      this.onChange(key, val, this.name);
    }
  }

  get expandable() {
    return this.name == "child";
  }
}
